"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingModifiers = exports.distributionModifiers = exports.distributionModifiersConfig = exports.alignmentModifiers = exports.alignmentModifiersConfig = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = require("styled-components");

var _styledComponentsModifiers = require("styled-components-modifiers");

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _dynamicModifiers = require("../../../utils/dynamicModifiers");

var _Column = _interopRequireDefault(require("../Column"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alignmentModifiersConfig = {
  start: function start() {
    return (0, _styledComponents.css)(["justify-content:flex-start;text-align:start;"]);
  },
  center: function center() {
    return (0, _styledComponents.css)(["justify-content:center;text-align:center;"]);
  },
  end: function end() {
    return (0, _styledComponents.css)(["justify-content:flex-end;text-align:end;"]);
  },
  top: function top() {
    return (0, _styledComponents.css)(["align-items:flex-start;"]);
  },
  middle: function middle() {
    return (0, _styledComponents.css)(["align-items:center;"]);
  },
  bottom: function bottom() {
    return (0, _styledComponents.css)(["align-items:flex-end;"]);
  }
};
exports.alignmentModifiersConfig = alignmentModifiersConfig;
var alignmentModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)(alignmentModifiersConfig, 'alignment');
exports.alignmentModifiers = alignmentModifiers;
var distributionModifiersConfig = {
  around: function around() {
    return (0, _styledComponents.css)(["justify-content:space-around;"]);
  },
  between: function between() {
    return (0, _styledComponents.css)(["justify-content:space-between;"]);
  }
};
exports.distributionModifiersConfig = distributionModifiersConfig;
var distributionModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)(distributionModifiersConfig, 'distribution');
exports.distributionModifiers = distributionModifiers;
var spacingModifiers = (0, _dynamicModifiers.applyDynamicModifiers)('spacing', function (_ref) {
  var spacingProp = _ref.spacing;
  return (0, _styledComponents.css)(["margin-left:-", ";margin-right:-", ";> ", "{padding-left:", ";padding-right:", ";}"], (0, _rem.default)(_spacing.default.base * spacingProp), (0, _rem.default)(_spacing.default.base * spacingProp), _Column.default, (0, _rem.default)(_spacing.default.base * spacingProp), (0, _rem.default)(_spacing.default.base * spacingProp));
});
exports.spacingModifiers = spacingModifiers;